import React, { useContext } from 'react';
import { useAutoUpdate, usePlayerTimes } from '@24i/player-utils-react';
import { formTimeString } from '@24i/player-utils';
import { useTheme } from '@24i/nxg-sdk-higgs/src/hooks/useTheme';
import { PlayerUIContext } from '@24i/player-ui';
import { getFont } from '@24i/nxg-sdk-higgs/src/StyleSheet';
import { Time } from '../PlayerUI/RegularView/components/PlayerFooter/styled';
const HOUR_MS = 60 * 60 * 1000;
export const Duration = ({ playerInstance, programRange, showHours, showIsLive, className, style, }) => {
    var _a;
    const { durationTime } = usePlayerTimes(playerInstance);
    const { programEnd } = (playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.getMetadata()) || { programEnd: 0 };
    const rangeEnd = (_a = programRange === null || programRange === void 0 ? void 0 : programRange.end) !== null && _a !== void 0 ? _a : programEnd;
    useAutoUpdate();
    const isLive = !!(playerInstance === null || playerInstance === void 0 ? void 0 : playerInstance.live);
    const finalShowHours = showHours === true || (showHours === 'auto' && (isLive || durationTime > HOUR_MS));
    const timeString = formTimeString(isLive ? rangeEnd || Date.now() : durationTime, finalShowHours, isLive);
    const { state: { isVolumeOpened }, } = useContext(PlayerUIContext);
    const { theme } = useTheme();
    return (React.createElement(Time, { "data-test": "Duration-Time", testID: "total_time", className: `Duration ${className}`, style: Object.assign(Object.assign({}, getFont(theme, 'h5')), style), theme: theme, isVolumeOpened }, showIsLive && isLive && !rangeEnd ? 'LIVE' : timeString));
};
Duration.defaultProps = {
    showHours: true,
    showIsLive: true,
    className: '',
    style: null,
};
//# sourceMappingURL=index.js.map